import { SVGProps } from 'react';

export const DoneIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.7857 14.924L4.29272 10.4311L6.00653 8.71726L8.7857 11.4964L13.9889 6.29321L15.7027 8.00702L8.7857 14.924ZM10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0Z"
        fill="currentColor"
      />
    </svg>
  );
};
